import React from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { hideError } from "store/reducers/errorReducer";
import { Button, Stack, Typography } from "@mui/material";
import { DialogWindow } from "UI/DialogWindow";

export const ErrorDialog = () => {
  const dispatch = useAppDispatch();
  const message = useAppSelector((state) => state.error?.message);

  const closeError = () => dispatch(hideError());

  if (!message) return null;

  return (
    <DialogWindow
      open={true}
      withCloseButton
      reducedSize
      handleClose={closeError}
      title={
        <Typography
          sx={{ fontWeight: "bold", fontSize: "1.4em" }}
        >
          Oops!
        </Typography>
      }
      content={<Typography mt={2} mb={2}>{message.toString()}</Typography>}
      actions={
        <Stack justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <Button variant="contained" onClick={closeError}>
            Got it
          </Button>
        </Stack>
      }
    />
  );
};
